import type { PropsWithChildren } from "react";

import { Box, Heading, Stack } from "@vinomofo/components";

export interface BlockWithHeadingProps {
  heading: string;
  divider?: boolean;
}

export const BlockWithHeading = ({
  heading,
  divider = true,
  children,
}: PropsWithChildren<BlockWithHeadingProps>): JSX.Element => {
  return (
    <Box
      flexBasis={["100%", "100%", "31.034%"]}
      maxWidth={["100%", "100%", "360px"]}
      paddingTop={["20px", "20px", "40px"]}
    >
      <Stack space={4}>
        <Heading as="h4" variant="xs">
          {heading}
        </Heading>
        {divider && <Box backgroundColor="divider" height="1px" />}
        {children}
      </Stack>
    </Box>
  );
};
